import { CurrentUser_myTeams } from 'src/queries/types/CurrentUser'

export type ITeam = CurrentUser_myTeams

export enum ETeamUserRole {
  owner = 'owner',
  member = 'member',
  collaborator = 'collaborator'
}
